export default {
	vipBenefits: {
		salaryTitle: 'Salario VIP',
		benefitsTitle: 'Beneficios',
		yourVipProgress: 'Tu Progreso VIP',
		progressToVip: '{percent}% hasta VIP {level}',
		vipMax: 'Nivel Máximo Alcanzado',
		vipLevelBenefits: 'Nivel y Beneficios VIP',
		betXpRule: 'Apuesta {amount} = {xp}EXP',
		btnReceive: 'Recibir',
		btnJoinIn: 'Unirse',
		btnReceived: 'Recibido',
		btnExpired: 'Expirado',
		btnNotSettled: 'No Liquidado',
		btnComingSoon: 'Próximamente',
		btnViewMore: 'Ver más',
		btnContactNow: 'Contactar',
		guestTitleLevelup: 'Bono de Subida de Nivel',
		guestTitleDaily: 'Salario Diario',
		guestTitleWeekly: 'Salario Semanal',
		guestTitleMonthly: 'Salario Mensual',
		guestTitleCashback: 'Reembolso',
		guestTitleRescue: 'Bono de Rescate',
		guestTitleEvents: 'Eventos VIP',
		guestTitleSupport: 'Soporte VIP',
		guestDescLevelup: 'Recibe un bono único cada vez que alcanzas un nuevo nivel VIP.',
		guestDescDaily: 'Reclama una recompensa de salario diario a medida que sube tu nivel VIP.',
		guestDescWeekly: 'Reclama una recompensa de salario semanal a medida que sube tu nivel VIP.',
		guestDescMonthly: 'Reclama una recompensa de salario mensual a medida que sube tu nivel VIP.',
		guestDescCashback: 'Gana reembolso por tus gastos en juegos.',
		guestDescRescue: 'Obtén un bono de rescate para ayudarte a recuperarte.',
		guestDescEvents: 'Los niveles VIP más altos desbloquean más recompensas de eventos exclusivos.',
		guestDescSupport: 'Soporte VIP dedicado para una asistencia más rápida.',
		comingSoonHint: 'Beneficio próximamente, estén atentos',
		receiveSuccess: 'Recompensa recibida',
		receiveFailed: 'Error al recibir recompensa',
		typeUpgrade: 'Bono de Subida de Nivel',
		typeDailySalary: 'Salario Diario',
		typeWeeklySalary: 'Salario Semanal',
		typeMonthlySalary: 'Salario Mensual',
		typeRebate: 'Reembolso',
		typeRescue: 'Bono de Rescate',
		typeVipActivity: 'Eventos VIP',
		typeVipService: 'Soporte VIP',
		tooltipRecharge: 'Recarga {current}/{target}',
		tooltipBets: 'Apuestas {current}/{target}',
		progressRecharge: 'Recarga',
		progressBets: 'Apuestas',
		descUpgradeBonus: 'Bono de Ascenso VIP{level} ×{count}',
		descDailySalary: 'Salario Diario VIP{level} ×{count}',
		descWeeklySalary: 'Salario Semanal VIP{level} ×{count}',
		descMonthlySalary: 'Salario Mensual VIP{level} ×{count}',
		descUpgradeBonusPlain: 'Bono de Ascenso VIP{level}',
		descDailySalaryPlain: 'Salario Diario VIP{level}',
		descWeeklySalaryPlain: 'Salario Semanal VIP{level}',
		descMonthlySalaryPlain: 'Salario Mensual VIP{level}',
		descRebate: 'Reembolso de Juegos VIP{level}',
		descRescue: 'Bono de Rescate VIP{level}',
		descVipActivity: 'Los niveles VIP más altos desbloquean más recompensas de eventos exclusivos.',
		descVipService: 'Soporte VIP dedicado para una asistencia más rápida.',
		allBenefits: 'Todos los Beneficios',
		vipClubTitle: 'VIP Club',
		more: 'Más',
		moreDesc: 'Consulte nuestras promociones para más detalles.',
		promotions: 'Promociones',
		highlightsTitle: '8 Características Destacadas',
		highlightSupport: 'Soporte VIP Exclusivo',
		highlightLevelup: 'Bono de Subida de Nivel',
		highlightSalary: 'Salario VIP',
		highlightRescue: 'Bono de Rescate VIP',
		highlightGifts: 'Regalos\nExclusivos VIP',
		highlightEvents: 'Eventos VIP',
		highlightService: 'Servicio\nVIP Dedicado',
		highlightWallet: 'Cartera de\nCrédito VIP',
		currentLevel: 'Nivel Actual',
		keepPlayingReach: 'Sigue jugando para alcanzar',
		higherLevelRewards: 'Nivel más alto, mayores recompensas',
		levelUpUnlock: 'Sube de nivel para desbloquear beneficios exclusivos y disfrutar de una experiencia premium.',
		yourVipBenefits: 'Tus Beneficios VIP',
		viewVipLevels: 'Ver Niveles VIP',
		exclusiveBenefitsTitle: 'Tus Beneficios Exclusivos',
		tipExclusiveRewards: 'Recompensas Exclusivas',
		tipHigherRakeback: 'Mayor Devolución',
		tipPrioritySupport: 'Soporte Prioritario',
		levelGroupBronze: 'Bronze',
		levelGroupBrass: 'Brass',
		tableLevel: 'Nivel',
		tableRequiredXp: 'EXP requerida',
		tableLevelUpBonus: 'Bono de subida de nivel',
		tableDailyRakeback: 'Devolución diaria',
		tableWeeklyLossback: 'Reembolso semanal por pérdidas',
		signIn: 'Iniciar sesión',
		vipClubDefaultDesc: 'Únete ahora a nuestro VIP Club y prepárate para recibir regalos, sorteos y funciones increíbles.',
	},
};
